import { gql, TypedDocumentNode } from '@apollo/client'

import { ATTRIBUTE_FRAGMENT } from './attribute'

import type { AbTestsVariantsSchemaDTO } from 'features/ab-tests/api/types/abTestsVariantsSchemaDTO'

export const PREBID_STACK_FRAGMENT: TypedDocumentNode<AbTestsVariantsSchemaDTO['prebidStack']> =
  gql`
    ${ATTRIBUTE_FRAGMENT}

    fragment abTestsVariantsPrebidStackFragment on AbTestsVariantsPrebidStack {
      auctionDelay {
        auctionDelay {
          ...abTestsVariantsAttributesFragment
        }
        customAuctionDelayEnabled {
          ...abTestsVariantsAttributesFragment
        }
        label
      }
      customizeNonConsentTrafficMonetization {
        ...abTestsVariantsAttributesFragment
      }
      domainAmazonEnabled {
        ...abTestsVariantsAttributesFragment
      }

      label
      monetizeNonConsentTraffic {
        ...abTestsVariantsAttributesFragment
      }
      prebidStackEnabled {
        ...abTestsVariantsAttributesFragment
      }
      prebidTimeout {
        customPrebidTimeoutEnabled {
          ...abTestsVariantsAttributesFragment
        }
        prebidTimeout {
          ...abTestsVariantsAttributesFragment
        }
        label
      }

      bidders {
        label
        items {
          id
          csEnabled {
            ...abTestsVariantsAttributesFragment
          }
          s2sEnabled {
            ...abTestsVariantsAttributesFragment
          }
          priority {
            ...abTestsVariantsAttributesFragment
          }
          validValues
        }
      }

      prebidModules {
        label
        analytics {
          label
          items {
            enabled {
              ...abTestsVariantsAttributesFragment
            }
            id
          }
        }
        general {
          label
          items {
            enabled {
              ...abTestsVariantsAttributesFragment
            }
            id
          }
        }
        userId {
          label
          items {
            enabled {
              ...abTestsVariantsAttributesFragment
            }
            id
          }
        }
        vendorSpecific {
          label
          items {
            enabled {
              ...abTestsVariantsAttributesFragment
            }
            id
          }
        }
      }
    }
  `
